import React, { Component } from 'react';

class PrintConsentBonding extends Component {

    render() {
        const { customer, data } = this.props;

        const now = new Date();

        const month = String(now.getMonth() + 1).padStart(2, '0'); // 01–12
        const year = now.getFullYear(); // 2026

        return (
            <div className="print-page">

                {/* Quốc hiệu */}
                <div className="header">
                    <div className="header-left">
                        Công ty TNHH Anh Nguyễn Beauty
                        <br />
                        Cơ sở KB, CB: Nha khoa CHINGO
                    </div>

                    <div className="header-center">
                        <div className="fw-bold uppercase">
                            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                        </div>
                        <div className="national-sub">
                            Độc lập - Tự do - Hạnh phúc
                        </div>
                    </div>

                    <div className="header-right"></div>
                </div>

                {/* Tiêu đề */}
                <div className="text-center fw-bold uppercase mt-24" style={{ fontSize: 18 }}>
                    GIẤY ĐỒNG Ý GẮN CHẶT RĂNG
                </div>

                {/* I. Nội dung đồng ý */}
                <div className="mt-24 fw-bold">I. NỘI DUNG ĐỒNG Ý</div>
                <div className="mt-16">
                    Tôi xác nhận rằng:
                </div>

                <ol>
                    <li>
                        Răng thẩm mỹ (sứ/veneer/mão) sẽ được <b>gắn chặt cố định</b> bằng vật liệu nha khoa chuyên dụng.
                    </li>
                    <li>
                        Tôi hiểu rằng:
                        <ul>
                            <li>Không thể tự tháo răng tại nhà</li>
                            <li>
                                Việc tháo (nếu có) chỉ do bác sĩ thực hiện và
                                <b> có thể ảnh hưởng răng thật</b>
                            </li>
                            <li>
                                Trong một số trường hợp <b>không thể hoàn nguyên răng như ban đầu</b>
                            </li>
                        </ul>
                    </li>
                </ol>

                {/* II. Nhận thức rủi ro */}
                <div className="mt-24 fw-bold">II. NHẬN THỨC RỦI RO</div>
                <div className="mt-16">
                    Tôi chấp nhận các rủi ro có thể xảy ra:
                </div>

                <ul>
                    <li>Bong, vỡ răng do ăn nhai sai cách, tai nạn, nghiến răng</li>
                    <li>Tuổi thọ răng thẩm mỹ <b>không vĩnh viễn</b></li>
                    <li>Kết quả phụ thuộc vào chăm sóc & tái khám</li>
                </ul>

                {/* III. Cam kết */}
                <div className="mt-24 fw-bold">III. CAM KẾT</div>

                <ul>
                    <li>Không tự ý can thiệp, tháo, cạy răng</li>
                    <li>Tuân thủ hướng dẫn của bác sĩ</li>
                    <li>Không khiếu nại nếu răng hỏng do lỗi sử dụng</li>
                </ul>

                {/* Ký xác nhận */}
                <div className="mt-32 fw-bold text-right">
                    Khách hàng ký xác nhận
                </div>
                <div className='text-right'>
                    (Ký - ghi rõ họ tên - ngày …… / …… / ……)
                </div>


                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        @media print {
                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 14pt;
                                line-height: 1.5;
                                color: #000;
                            }

                            .print-page {
                                width: 100%;
                            }

                            .text-center {
                                text-align: center;
                            }

                            .text-right {
                                text-align: right;
                            }

                            .fw-bold {
                                font-weight: bold;
                            }

                            .uppercase {
                                text-transform: uppercase;
                            }

                            .mt-16 { margin-top: 16px; }
                            .mt-24 { margin-top: 24px; }
                            .mt-32 { margin-top: 32px; }

                            ul {
                                margin-left: 20px;
                                padding-left: 10px;
                            }

                            li {
                                margin-bottom: 6px;
                            }

                            /* HEADER TỔNG */
                            .header {
                                display: grid;
                                grid-template-columns: 0.8fr 2fr 0.8fr;
                                align-items: start;
                                margin-bottom: 16px;
                            }

                            /* CỘT TRÁI */
                            .header-left {
                                font-size: 11pt;      /* nhỏ hơn body */
                                line-height: 1.3;
                                text-align: left;
                            }

                            /* CỘT GIỮA – QUỐC HIỆU */
                            .header-center {
                                font-size: 12pt;      /* nhỏ hơn body (14pt) */
                                line-height: 1.35;
                                text-align: center;
                            }

                            /* Gạch dưới khẩu hiệu */
                            .header-center .national-sub {
                                display: inline-block;
                                padding-bottom: 2px;
                                border-bottom: 1px solid #000;
                            }

                            /* RIGHT */
                            .header-right {
                                /* để trống để cân bố cục */
                            }
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintConsentBonding;
